import createIcon from '../../createIcon';

/**
 * @component @name Send
 * @description Google Material SVG icon component, renders SVG Element with children.
 *
 * @preview ![img](data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjQiIGhlaWdodD0iMjQiIHZpZXdCb3g9IjAgMCAyNCAyNCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj48cGF0aCBkPSJNMS41MSAyMUwyMi41IDEyTDEuNTEgM0wxLjUgMTBMMTYuNSAxMkwxLjUgMTRMMS41MSAyMVoiIGZpbGw9ImJsYWNrIi8+Cjwvc3ZnPgo=)
 *
 * @param {Object} props - Google Material icons props and any valid SVG attribute
 * @returns {JSX.Element} JSX Element
 *
 */
const Send = createIcon('Send', [
  ['path', { d: 'M1.51 21L22.5 12L1.51 3L1.5 10L16.5 12L1.5 14L1.51 21Z', key: '1mhkdm' }],
]);

export default Send;
